// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"c113d65c","892":"43f3fbaa"}[chunkId] + ".chunk.js";
};